import { BasePlanningItem } from './basePlanningItem.model';
import { Article } from './article.model';

export class PlanningItem extends BasePlanningItem {
    constructor(article: string, isDirty: boolean) {
        super(new Article(article, article, 0, true,''), isDirty);
    }
}
